<div *ngIf="!isAdmin && !isCorporateAccount" class="sidenav bg-dark text-light" [ngClass]="{ 'is-open': isMenuExpanded }">
	<div class="pin">
		<button type="button" (click)="toggleExpanded()"><i class="fal fa-thumbtack text-light"></i></button>
	</div>

	<button [routerLink]="['/dashboard']" class="bg-transparent border-0">
		<img [src]="logoUrl" (error)="useFallbackLogo($event)" class="logo" alt="Company Logo" style="max-height: 100px" />
	</button>

	<div [style.min-height]="minHeight">
		<!-- MENU ITEMS -->
		<ul class="mainmenu">
			<li *ngIf="canAccessJobs">
				<a href="/jobs" [routerLink]="['/jobs']" routerLinkActive="bg-primary text-white"> <i class="fal fa-clipboard-list"></i>Jobs </a>
			</li>

			<li *ngIf="canAccessSharedJobs">
				<a href="/shared-jobs" [routerLink]="['/shared-jobs']" routerLinkActive="bg-primary text-white">
					<i class="fal fa-inbox-in"></i>Sent Jobs
					<div *ngIf="sharedJobCount > 0" class="bg-danger text-white px-2 py-1 side-menu-badge">
						{{ sharedJobCount }}
					</div>
				</a>
			</li>

			<li *ngIf="canAccessSchedule || canAccessSubcontractor">
				<a href="/schedule" [routerLink]="['/schedule']" routerLinkActive="bg-primary text-white"> <i class="fal fa-calendar-alt"></i>Schedule </a>
			</li>

			<li *ngIf="canAccessCustomers">
				<a href="/customers" [routerLink]="['/customers']" routerLinkActive="bg-primary text-white"> <i class="fal fa-users"></i>Customers </a>
			</li>

			<li *ngIf="canAccessBusinessDevelopment">
				<a href="/businessDevelopment" [routerLink]="['/businessDevelopment']" routerLinkActive="bg-primary text-white"> <i class="fal fa-handshake"></i>Business Dev </a>
			</li>

			<li *ngIf="canAccessCommissions">
				<a href="/commissions" [routerLink]="['/commissions']" routerLinkActive="bg-primary text-white"> <i class="fal fa-badge-percent"></i>Commissions </a>
			</li>

			<li *ngIf="canAccessSubcontractor">
				<a href="/subcontractors" [routerLink]="['/subcontractors']" routerLinkActive="bg-primary text-white"> <i class="fal fa-user-helmet-safety"></i>{{ subcontractorsMenuLabel }} </a>
			</li>

			<li *ngIf="canAccessWorkOrders">
				<a href="/workOrders" [routerLink]="['/workOrders']" routerLinkActive="bg-primary text-white"> <i class="fal fa-clipboard-list-check"></i>Work Orders </a>
			</li>

			<li *ngIf="canAccessVendors">
				<a href="/vendors" [routerLink]="['/vendors']" routerLinkActive="bg-primary text-white"> <i class="fal fa-user-circle"></i>Vendors </a>
			</li>

			<li *ngIf="canAccessEquipment">
				<a href="/equipment" [routerLink]="['/equipment']" routerLinkActive="bg-primary text-white"> <i class="fal fa-tags"></i>Equipment </a>
			</li>

			<li *ngIf="canAccessPropertyProfiles">
				<a href="/property-profiles" [routerLink]="['/property-profiles']" routerLinkActive="bg-primary text-white"> <i class="fal fa-house-chimney"></i>Properties </a>
			</li>

			<li *ngIf="canAccessInvoices">
				<a href="/invoices" [routerLink]="['/invoices']" routerLinkActive="bg-primary text-white"> <i class="fal fa-file-invoice"></i>Invoices </a>
			</li>

			<li *ngIf="canAccessPayments">
				<a href="/payments" [routerLink]="['/payments']" routerLinkActive="bg-primary text-white">
					<i class="fal fa-money-check-alt"></i>Payments
					<div *ngIf="failedPaymentsCount > 0" class="bg-danger text-white px-2 py-1 side-menu-badge" title="Failed payments that need attention">
						{{ failedPaymentsCount }}
					</div>
				</a>
			</li>

			<li *ngIf="canAccessPayables">
				<a href="/payables" [routerLink]="['/payables']" routerLinkActive="bg-primary text-white">
					<i class="fal fa-envelope-open-dollar"></i>Payables
					<div *ngIf="payablesAwaitingApprovalCount > 0" class="bg-danger text-white px-2 py-1 side-menu-badge">
						{{ payablesAwaitingApprovalCount }}
					</div>
				</a>
			</li>

			<li *ngIf="canAccessTimeclock">
				<a href="/timeclock" [routerLink]="['/timeclock']" routerLinkActive="bg-primary text-white"> <i class="fal fa-clock"></i>Time Clock </a>
			</li>

			<li *ngIf="canAccessInventory">
				<a href="/inventory" [routerLink]="['/inventory']" routerLinkActive="bg-primary text-white"> <i class="fal fa-shelves"></i>Inventory </a>
			</li>

			<li *ngIf="useQuickbooksDesktop && canAccessQuickbooks">
				<a href="/quickbooks" [routerLink]="['/quickbooks']" routerLinkActive="bg-primary text-white">
					<div class="quickbooks"><span class="quickbooks-icon">K</span><span class="quickbooks-text">Quickbooks</span></div>
				</a>
			</li>

			<li *ngIf="useXactware && canAccessXactware">
				<a href="/xactware" [routerLink]="['/xactware']" routerLinkActive="bg-primary text-white">
					<i class="fal fa-exchange"></i>Xactware
					<div *ngIf="xactAssignmentCount > 0" class="bg-danger text-white px-2 py-1 side-menu-badge">
						{{ xactAssignmentCount }}
					</div>
				</a>
			</li>

			<li *ngIf="canAccessTasks">
				<a href="/tasks" [routerLink]="['/tasks']" routerLinkActive="bg-primary text-white">
					<i class="fal fa-list-check"></i>Tasks
					<!-- Task badge removed from the main menu - open tasks are surfaced by the top menu notifications instead. -->
				</a>
			</li>

			<li *ngIf="canAccessEmailLogs">
				<a href="/emailLogs" [routerLink]="['/emailLogs']" routerLinkActive="bg-primary text-white"> <i class="fal fa-envelope"></i>Email Logs </a>
			</li>

			<li *ngIf="canAccessReporting">
				<a href="/reporting" [routerLink]="['/reporting']" routerLinkActive="bg-primary text-white">
					<div class="reporting"><i class="fal fa-chart-pie"></i>Reporting</div>
				</a>
			</li>

			<li *ngIf="canAccessCustomReports">
				<a href="/custom-reports" [routerLink]="['/custom-reports']"
				   routerLinkActive="bg-primary text-white">
					<i class="fal fa-chart-line"></i>Custom Reports
				</a>
			</li>
			<li *ngIf="canAccessTextChat">
                <a href='/text-chat'
                   [routerLink]="['/text-chat']"
                   routerLinkActive="bg-primary text-white">
                    <i class="fal fa-messages"></i>Text Chat
                    <div class="side-menu-badge-group">
                        <div *ngIf="textChatErrorMessagesCount > 0" class="bg-warning text-dark px-2 py-1 side-menu-badge-item">
                            {{textChatErrorMessagesCount}}
                        </div>
                        <div *ngIf="textChatUnreadMessagesCount > 0" class="bg-danger text-white px-2 py-1 side-menu-badge-item">
                            {{textChatUnreadMessagesCount}}
                        </div>
                    </div>

				</a>
			</li>

			<li *ngIf="canAccessUsers">
				<a href="/users" [routerLink]="['/users']" routerLinkActive="bg-primary text-white"> <i class="fal fa-user-tie"></i>Users </a>
			</li>

			<li *ngIf="canAccessSetup">
				<a href="/setup" [routerLink]="['/setup']" routerLinkActive="bg-primary text-white"> <i class="fal fa-cogs"></i>Setup </a>
			</li>

			<li *ngIf="canManageOnboarding">
				<a href='/learning-paths'
				   [routerLink]="['/learning-paths']"
				   routerLinkActive="bg-primary text-white">
					<i class="fal fa-graduation-cap"></i>Learning Paths
				</a>
			</li>

			<li *ngIf="canViewBranchOnboarding">
				<a href='/branch-learning-paths'
				   [routerLink]="['/branch-learning-paths']"
				   routerLinkActive="bg-primary text-white">
					<i class="fal fa-graduation-cap"></i>Learning Paths
				</a>
			</li>

			<!--<li>
				<a href='javascript:void()' (click)="logout()">
					<i class="fal fa-sign-out"></i>Sign Out
				</a>
			</li>-->
		</ul>
	</div>
	<!--[ngClass]="{ 'support-center-expanded' : isMenuExpanded, 'support-center-collapsed' : !isMenuExpanded }"-->
	<div class="pt-2 side-menu-footer">
		<!--<div style="font-size:18px" class="border-bottom" [ngClass]="{ 'support-header-expanded' : (isMenuExpanded || hoveringSideMenu), 'support-header-collapsed': !isMenuExpanded }">
			<span *ngIf="isMenuExpanded || hoveringSideMenu">
				Support
			</span>
			<i *ngIf="!isMenuExpanded && ! hoveringSideMenu" class="fad fa-circle-info"></i>
		</div>-->
		<ul class="mainmenu mt-2 fw-lighter">
			<!--<li *ngIf="useZift">
				<a href='https://portal.zift.io/console/' target="_blank">
					<i class="fad fa-credit-card"></i>Zift Console
				</a>
			</li>
			<li *ngIf="!useZift">
				<a href='https://apply.zift.io/jobsight/' target="_blank">
					<i class="fad fa-credit-card"></i>Pmt Processing
				</a>
			</li>
			<li>
				<a href='https://fast.wistia.com/embed/channel/jvv59mc5e0?wchannelid=jvv59mc5e0' target="_blank">
					<i class="fad fa-play"></i>Sight School
				</a>
			</li>
			<li #showReleaseNotesButton (click)="showVersionHistory()">

				<a style="cursor:pointer">
					<i class="fad fa-history"></i>Release Notes
				</a>
			</li>
			<li>
				<a href='https://forms.zohopublic.com/jobsight1/form/Contactforsupport/formperma/QJkD52MQeyERlCFVttsy5cN72LiT1B_9wjS1mqO9TRg' target="_blank">
					<i class="fad fa-ticket"></i>Submit Ticket
				</a>
			</li>-->
			<!-- Old GoHighLevel support -->
			<!--<li>
				<a href='https://support.jobsight.com/create-support-ticket' target="_blank">
					<i class="fad fa-ticket"></i>Submit Ticket
				</a>
			</li>-->
			<!--<li *ngIf="idStartsWith911()">
				<a href="https://jobsight.com/911-restoration-resource-hub" target="_blank">
					<i class="fad fa-home"></i>911 Hub
				</a>
			</li>-->

			<li [ngClass]="{ 'account-id-expanded': isMenuExpanded || hoveringSideMenu, 'account-id-collapsed': !(isMenuExpanded || hoveringSideMenu) }">
				<span *ngIf="isMenuExpanded || hoveringSideMenu"> Account ID:&nbsp; </span>{{ jobSightId }}
			</li>
		</ul>
	</div>
</div>

<div *ngIf="isAdmin" class="sidenav bg-dark text-light" [ngClass]="{ 'is-open': isMenuExpanded }">
	<div class="pin">
		<button type="button" (click)="toggleExpanded()"><i class="fal fa-thumbtack text-light"></i></button>
	</div>

	<button [routerLink]="['/']" class="bg-transparent border-0"><div class="logo"></div></button>

	<!-- MENU ITEMS -->
	<ul class="mainmenu">
		<li *ngIf="canAccessGlobalAdmin">
			<a href="/globalAdmin" [routerLink]="['/globalAdmin']" routerLinkActive="bg-primary text-white"> <i class="fal fa-burst"></i>Global Admin </a>
		</li>

		<!--<li>
			<a href='javascript:void()' (click)="logout()">
				<i class="fal fa-sign-out"></i>Sign Out
			</a>
		</li>-->
	</ul>
</div>

<div *ngIf="isCorporateAccount && isCorporateAdminUser" class="sidenav bg-dark text-light" [ngClass]="{ 'is-open': isMenuExpanded }">
	<!-- MENU ITEMS -->
	<ul class="mainmenu mainmenu-no-logo">
		<li *ngIf="canAccessCorporateDashboard">
			<a href="/corporate-view" [routerLink]="['/corporate-view']" routerLinkActive="bg-primary text-white"> <i class="fad fa-bar-chart"></i>Dashboard </a>
		</li>

		<li *ngIf="canAccessFranchiseViews" class="border-bottom pt-3 mb-3"></li>

		<li *ngIf="canAccessFranchiseViews" class="ms-3"><i class="fad fa-building"></i>Franchise Views</li>

		<li *ngIf="canAccessFranchiseJobs">
			<a href="/franchise-jobs" [routerLink]="['/franchise-page-view/jobs']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Jobs</span>
			</a>
		</li>

		<li *ngIf="canAccessFranchiseInvoices">
			<a href="/franchise-invoices" [routerLink]="['/franchise-page-view/invoices']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Invoices</span>
			</a>
		</li>

		<li *ngIf="canAccessFranchisePayments">
			<a href="/franchise-payments" [routerLink]="['/franchise-page-view/payments']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Payments</span>
			</a>
		</li>

		<li *ngIf="canAccessFranchiseSchedule">
			<a href="/franchise-schedule" [routerLink]="['/franchise-page-view/schedule']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Schedule</span>
			</a>
		</li>

		<li *ngIf="canAccessFranchiseBusinessDev">
			<a href="/franchise-dispatch" [routerLink]="['/franchise-page-view/businessDevelopment']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Business Dev</span>
			</a>
		</li>
		<li *ngIf="canAccessFranchiseCommissions">
			<a href="/corporate-commissions" [routerLink]="['/corporate-commissions']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Commissions</span>
			</a>
		</li>
		<li *ngIf="canAccessCorporateTasks">
			<a href="/corporate-tasks" [routerLink]="['/corporate-tasks']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Tasks</span>
			</a>
		</li>

		<li *ngIf="canAccessCorporateKpis" class="border-bottom pt-3 mb-3"></li>

		<li *ngIf="canAccessCorporateKpis" class="ms-3"><i class="fad fa-pie-chart"></i>KPIs</li>

		<li *ngIf="canAccessCorporateKpis">
			<a href="/corporate-dashboard/revenue" [routerLink]="['/corporate-dashboard/revenue']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Revenue</span>
			</a>
		</li>

		<li *ngIf="canAccessCorporateKpis">
			<a href="/corporate-dashboard/productivity" [routerLink]="['/corporate-dashboard/productivity']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Productivity</span>
			</a>
		</li>

		<li *ngIf="canAccessCorporateKpis">
			<a href="/corporate-dashboard/performance" [routerLink]="['/corporate-dashboard/performance']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Performance</span>
			</a>
		</li>

		<li *ngIf="canAccessCorporateKpis">
			<a href="/corporate-dashboard/customer-experience" [routerLink]="['/corporate-dashboard/customer-experience']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Cust Experience</span>
			</a>
		</li>

		<li *ngIf="canAccessCorporateReports" class="border-bottom pt-3 mb-3"></li>

		<li *ngIf="canAccessCorporateReports" class="ms-3"><i class="fad fa-bar-chart"></i>Reports</li>

		<li *ngIf="canAccessCorporateReports && canAccessCorporateJobMasterBillingReports">
			<a href="/corporate-reporting/jobMasterReport" [routerLink]="['/corporate-reporting/jobMasterReport']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Job Master Report</span>
			</a>
		</li>

		<li *ngIf="canAccessCorporateReports && canAccessCorporateJobMasterBillingReports">
			<a href="/corporate-reporting/billingReport" [routerLink]="['/corporate-reporting/billingReport']" routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Billing Report</span>
			</a>
		</li>

		<li *ngIf="canAccessCorporateReports">
			<a href='/corporate-custom-reports'
			   [routerLink]="['/corporate-custom-reports']"
			   routerLinkActive="bg-primary text-white">
				<span style="margin-left: 14px">Custom Reports</span>
			</a>
		</li>

		<li *ngIf="canAccessCorporatePriceBooks" class="border-bottom pt-3 mb-3"></li>

		<li *ngIf="canAccessCorporatePriceBooks">
			<a href="/setup/price-books" [routerLink]="['/setup/priceBooks']" routerLinkActive="bg-primary text-white"> <i class="fad fa-book-open-cover"></i>Price Books </a>
		</li>

		<li *ngIf="canAccessCorporateAdminPages" class="border-bottom pt-3 mb-3"></li>

		<li *ngIf="canAccessLearningPaths">
			<a href='/corporate-learning-paths'
			   [routerLink]="['/corporate-learning-paths']"
			   routerLinkActive="bg-primary text-white">
				<i class="fad fa-graduation-cap"></i>Learning Paths
			</a>
		</li>

		<li *ngIf="canAccessCorporateUsers">
			<a href="/corporate-users" [routerLink]="['corporate-users']" routerLinkActive="bg-primary text-white"> <i class="fad fa-users"></i>Corporate Users </a>
		</li>

		<li *ngIf="canAccessDispatchUsers">
			<a href="/dispatch-users" [routerLink]="['dispatch-users']" routerLinkActive="bg-primary text-white"> <i class="fad fa-users"></i>Dispatch Users </a>
		</li>

		<!-- Expands in place to its two pages, mirroring Setup -> Open API in the non-corporate view. -->
		<li *ngIf="canAccessCorporateOpenApi">
			<a href="javascript:void(0)" (click)="toggleCorporateOpenApiMenu()">
				<i class="fad fa-code"></i>OpenAPI
				<i class="fas ms-2" [ngClass]="isCorporateOpenApiMenuExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
			</a>
		</li>

		<ng-container *ngIf="canAccessCorporateOpenApi && isCorporateOpenApiMenuExpanded">
			<li>
				<a href="/corporate-open-api/keys" [routerLink]="['/corporate-open-api/keys']" routerLinkActive="bg-primary text-white">
					<span style="margin-left: 14px">OpenApi Keys</span>
				</a>
			</li>

			<li>
				<a href="/corporate-open-api/docs" [routerLink]="['/corporate-open-api/docs']" routerLinkActive="bg-primary text-white">
					<span style="margin-left: 14px">Docs</span>
				</a>
			</li>
		</ng-container>
	</ul>
</div>

<div *ngIf="isCorporateAccount && isDispatchUser" class="sidenav bg-dark text-light" [ngClass]="{ 'is-open': isMenuExpanded }">
	<!-- MENU ITEMS -->
	<ul class="mainmenu mainmenu-no-logo">
		<li *ngIf="canAccessFranchiseJobs">
			<a href="/franchise-dispatch" [routerLink]="['/franchise-page-view/jobs']" routerLinkActive="bg-primary text-white"> <i class="fad fa-building"></i>Dispatch </a>
		</li>

		<li *ngIf="canAccessFranchiseSchedule">
			<a href="/franchise-dispatch" [routerLink]="['/franchise-page-view/schedule']" routerLinkActive="bg-primary text-white"> <i class="fad fa-calendar"></i>Schedule </a>
		</li>

		<li *ngIf="canAccessFranchiseBusinessDev">
			<a href="/franchise-dispatch" [routerLink]="['/franchise-page-view/businessDevelopment']" routerLinkActive="bg-primary text-white"> <i class="fal fa-handshake"></i>Business Dev </a>
		</li>

		<li *ngIf="canAccessCorporateTasks">
			<a href="/corporate-tasks" [routerLink]="['/corporate-tasks']" routerLinkActive="bg-primary text-white"> <i class="fal fa-list-check"></i>Tasks </a>
		</li>
		<li>
			<a href="/assignments" [routerLink]="['/assignments']" routerLinkActive="bg-primary text-white">
				<i class="fal fa-user-circle-plus"></i>Assignments
				<div *ngIf="assignmentsBadge > 0" class="bg-danger text-white px-2 py-1 side-menu-badge">
					{{ assignmentsBadge }}
				</div>
			</a>
		</li>
	</ul>
</div>

<!--<version-release-dialog #versionDialog [isOpen]="showDialog" (onClose)="onVersionDialogClose()" [isMobile]="false"></version-release-dialog>-->
